import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Response } from "src/app/shared/models/Response";
import { Observable } from "rxjs";
import { TipoProveedorCorreo } from "../../models/CasillaDteRecibidos/TipoProveedorCorreo";

@Injectable({
   providedIn: "root",
})
export class TipoProveedorCorreoService {
   private REST_API_SERVER = environment.backend_server + "/CasillaCorreoDteRecibido";
   private auth = {};
   constructor(private http: HttpClient) {}

   mailTypes(): Observable<Response<TipoProveedorCorreo[]>> {
      return this.http.get<Response<TipoProveedorCorreo[]>>(this.REST_API_SERVER + "/mailTypes");
   }
}
